import { render, staticRenderFns } from "./CreateShopee.vue?vue&type=template&id=680f8a8b&scoped=true"
import script from "./CreateShopee.vue?vue&type=script&lang=js"
export * from "./CreateShopee.vue?vue&type=script&lang=js"
import style0 from "./CreateShopee.vue?vue&type=style&index=0&id=680f8a8b&prod&scoped=true&lang=css"
import style1 from "./CreateShopee.vue?vue&type=style&index=1&id=680f8a8b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "680f8a8b",
  null
  
)

export default component.exports